var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSdReferral(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11761_32518)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24 48C37.2548 48 48 37.2548 48 24C48 10.7452 37.2548 0 24 0C10.7452 0 0 10.7452 0 24C0 37.2548 10.7452 48 24 48Z",
    fill: "#EFF0F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.5 27.5C29.3926 25.4268 27.2214 24.5923 24.2652 24.5923C21.3089 24.5923 18.4711 25.7543 16.3637 27.8275C14.2564 29.9007 13.0483 32.7192 13 35.675C17.5052 37 24.2652 37 24.2652 37M29.8985 16.6333C29.8985 18.1274 29.305 19.5602 28.2485 20.6167C27.1921 21.6732 25.7592 22.2667 24.2652 22.2667C22.7711 22.2667 21.3382 21.6732 20.2818 20.6167C19.2253 19.5602 18.6318 18.1274 18.6318 16.6333C18.6318 15.1393 19.2253 13.7064 20.2818 12.65C21.3382 11.5935 22.7711 11 24.2652 11C25.7592 11 27.1921 11.5935 28.2485 12.65C29.305 13.7064 29.8985 15.1393 29.8985 16.6333Z",
    stroke: "#8152E0",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.6667 34.6667L38 31.3333M38 31.3333L34.6667 28M38 31.3333H31.3333C30.4493 31.3333 29.6014 31.6845 28.9763 32.3096C28.3512 32.9348 28 33.7826 28 34.6667C28 35.5507 28.3512 36.3986 28.9763 37.0237C29.6014 37.6488 30.4493 38 31.3333 38H33",
    stroke: "#8152E0",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11761_32518"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSdReferral);
export default __webpack_public_path__ + "static/media/sd-referral.e69b394eae44fb4cccbbddd4b37573b2.svg";
export { ForwardRef as ReactComponent };